export const environment = {
  production: true,
  server_url: '/2026/server-v1.0.0/php/ajax/ajax.php',
  event_name: 'Semana Mundial',
  event_year: '2026'
};
